// Status values that count as "Current" for a case module.
// Active/Outstanding (or module-equivalent) and blank/null statuses are
// Current; every other value (Completed, Lapsed, Closed, etc.) is Non-current.
//
// NOTE on `liability`: casing below ("Active", "Outstanding") mirrors the
// Asset module's confirmed Title Case values, but has NOT been verified
// against a live GET /case/liability/customer/:id response. Verify and
// correct this before relying on it — a casing mismatch will silently
// return zero "current" records since the backend does a case-sensitive
// Op.in match.
// NOTE on `policy`: casing below ("Active", "In Force") is an UNVERIFIED
// placeholder — the doc for this module guessed lowercase ('in force',
// 'applied for') with no evidence anywhere in the codebase, and Asset's own
// doc guessed wrong before (assumed uppercase, real data was Title Case).
// Inspect a live GET /case/policy/customer/:id response and correct this
// before relying on it.
export const CURRENT_CASE_STATUSES: Record<string, string[]> = {
  asset: ["Active", "Pending", ""],
  liability: ["Active", "Outstanding", ""],
  policy: ["Active", "In Force", "Applied For", ""],
};

// Comma-separated list suitable for the `status` query param on the case API
// (e.g. GET /case/asset/customer/:id?status=Active,Pending,)
export const getCurrentStatusParam = (
  module: keyof typeof CURRENT_CASE_STATUSES = "asset"
): string => CURRENT_CASE_STATUSES[module].join(",");
